var Backbone = require('backbone');
var _ = require('underscore');
var svg4everybody = require('svg4everybody');

//Backend urls chhemas to generate them on frontend
window.Urls = require('django_js_availability/reverse.js').Urls;

var Settings = require('front/Settings');
var Router = require('./Router');
var Utils = require('front/utils/Utils.js');

require('reset.css');
require('front/style.less');
require('front/utils.less');
require('front/fonts.less');
require('mq.genie-0.5.0.js');

//fix for hovers|active on mobile, WEIRD!
//fastclick solves this problem, but adds a bunch of other
$('body *').on('touchstart', function () {
});


import Promise from 'promise-polyfill';

if (!window.Promise) {
    window.Promise = Promise;
}


//Pervushinag закомментил, потому что в IE9-11 вместо того чтобы делать все хорошо, делает все плохо и все use внутри svg просто выпилпвает
//для случая когда свг с символами уже встроен в дум svg4everybody не только не нужен, но и вреден
//svg4everybody();


app.configure = Settings.configure;
app.configure();

window.app.vent = _.extend({}, Backbone.Events);

window.app.utils = Utils;

window.app.els = {
    $window: $(window),
    $body: $('body'),
    $htmlBody: $('html,body'),
    $content: $('.Content')
};

window.app.isPhoneLayout = function () {
    return window.innerWidth < 768;
};


// $.get(window.app.settings.staticUrl + 'svg/front/symbol/svg/sprite.symbol.svg', function (data) {
$.get('/static/svg/front/symbol/svg/sprite.symbol.svg', function (data) {
    var div = document.createElement('div');
    div.style.display = 'none';
    div.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
    document.body.insertBefore(div, document.body.childNodes[0]);
});

app.router = new Router();

//should be first, cause topNav listen topNavPopup events
app.views = {
};


$.fn.flashClass = function (className, delay) {
    var self = this;
    var timeout;
    this.addClass(className);
    clearTimeout(this.data('timeout'));
    timeout = setTimeout(function () {
        if (typeof self == 'object' && self.length) {
            self.removeClass(className);
            self.data('timeout', null);
        }
    }, delay);
    this.data('timeout', timeout);

    return this;
};

app.router.start();




//////////////////
// WEBPACK FOOTER
// ./assets/app/availability/App.js
// module id = 15
// module chunks = 0